import React, { useState } from "react";
import { Box, Grid,Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import OtpInput from "react-otp-input";
import { useForm, Controller} from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { otpVerify } from "../services/auth";
import { useHistory } from "react-router-dom";
import { formatError } from "../utils/functions";


const useStyles = makeStyles((theme) => ({
  helper: {
    marginTop:"0.3rem",
    height: "0.7rem",
    display: "flex",
    alignItems: "center",
    fontSize: "0.7rem",
    color: "red",
  },
  box: {
    padding: "5rem 0rem 1rem 4rem",
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down("sm")]: {
      padding: "1rem 2rem",
    },
  },
}));

const validationSchema = Yup.object().shape({
    otp: Yup.string().required("Otp is required").min(6,"Please enter the complete otp"),
  });

const OtpScreen = ({email}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [error, setError] = useState(null);
  const history = useHistory();
  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });
  const onSubmit = async (data) => {
    setError(null);
    data ={email, ...data}
    let response = await dispatch(otpVerify(data,{loader: true}));
    if(response === true){
        history.push('/onestack-data/login');
    }else{
        setError(response);
    }
  };
  return (
    <div>
      <Box className={classes.box}>
        <div className="otp-heading">Email Verification</div>
        <div className="otp-sub">
          Please verify your email address by clicking on the button below
        </div>
        <div className="error-message">{formatError(error)}</div>
        <div className="email-details">
          <div className="static">
            We have sent you a one time code on this Email
          </div>
          <div className="email">{email}</div>
        </div>
        <Grid container justifyContent="center" spacing={0}>
          <Grid item >
          <Controller
              name="otp"
              control={control}
              inputRef={register()}
              render={({ field: { name, value, onChange, onBlur } }) => {
                return (
                  <OtpInput
                    id="otp"
                    name={name}
                    onBlur={onBlur}
                    value={value}
                    onChange={onChange}
                    numInputs={6}
                    separator={<span>-</span>}
                  />
                );
              }}
            />
            <Typography
              variant="inherit"
              color="textSecondary"
              className={classes.helper}
            >
              {errors.otp?.message}
            </Typography>
          </Grid>
        </Grid>
        <div className="otp-not">
          Do not receive the code? <span>Re-send OTP</span>
        </div>
        <Box mt={3}>
          <button onClick={handleSubmit(onSubmit)} className="signup-button">
            Verify
          </button>
        </Box>
      </Box>
    </div>
  );
};

export default OtpScreen;
